import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import * as ROUTES from "./constants/routes";

import {
  HomePage,
  Scanner,
  TestResultPreviewPage,
  DataPrivacyPage,
  GetHelpPage,
  History
} from "./pages";
import TestPhoto from "./pages/TestPhoto/TestPhoto";

const RouterWithSupervisor = () => {
  return (
    <BrowserRouter>
      <Switch>
        <Route path={ROUTES.HOME} exact component={HomePage} />
        <Route exact path={ROUTES.SCANNER} component={Scanner} />
        <Route
          exact
          path={ROUTES.TEST_RESULT_PREVIEW}
          component={TestResultPreviewPage}
        />
        <Route exact path={ROUTES.DATA_PRIVACY} component={DataPrivacyPage} />
        <Route exact path={ROUTES.GET_HELP} component={GetHelpPage} />
        <Route exact path={ROUTES.TEST_PHOTO} component={TestPhoto} />
        <Route exact path={ROUTES.HISTORY} component={History} />
        <Redirect to={ROUTES.HOME} />
      </Switch>
    </BrowserRouter>
  );
};

export default RouterWithSupervisor;
